'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiDocumentDelete = function TiDocumentDelete(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.8 12.2l-6.6-6.7c-0.3-0.3-0.8-0.5-1.2-0.5h-13.3c-2.8 0-5 2.2-5 5v20c0 2.8 2.2 5 5 5h16.6c2.8 0 5-2.2 5-5v-16.7c0-0.4-0.1-0.8-0.5-1.1z m-3.5 1.1h-1.8c-1.4 0-2.5-1.1-2.5-2.5v-1.8l4.3 4.3z m-1 18.4h-16.6c-1 0-1.7-0.8-1.7-1.7v-20c0-0.9 0.7-1.7 1.7-1.7h11.6v2.5c0 2.3 1.9 4.2 4.2 4.2h2.5v15c0 0.9-0.7 1.7-1.7 1.7z m-3.3-8.4h-10c-0.9 0-1.7-0.7-1.7-1.6s0.8-1.7 1.7-1.7h10c0.9 0 1.7 0.7 1.7 1.7s-0.8 1.6-1.7 1.6z' })
        )
    );
};

exports.default = TiDocumentDelete;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/document-delete.js
// module id = 3609
// module chunks = 0